import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { MatDialog } from '@angular/material';
import { ChequeClearPopupComponent } from '../cheque-clear-popup/cheque-clear-popup.component';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-agent-transaction',
  templateUrl: './agent-transaction.component.html',
  styleUrls: ['./agent-transaction.component.scss']
})
export class AgentTransactionComponent implements OnInit {
  agent_id: any;
  booth_code: any;
  agent_code: any;
  business_details: Object;
  business_available: boolean = false;
  title: any;
  transaction_log_date_list(transaction_log_date_list: any) {
    throw new Error("Method not implemented.");
  }
  wallet_balance: any;
  transaction_log: any;

  constructor(private httpService: HttpService, private dialog: MatDialog, private global: GlobalService) {
    // this.global.set_master_page_title = "Agent Transactions"
    this.title = this.global._active_display_name;

  }


  checkBoothExists() {
    let data_dict = {
      'booth_code': this.booth_code,
      'agent_code': this.agent_code,

    };
    console.log(data_dict);
    this.httpService.checkForBoothAndAgentExists(data_dict).subscribe((data) => {
      console.log(data);
      if (data['found']) {
        this.business_details = data;
        this.business_available = true;
        this.agent_id = data['agent_id']
        this.getData()
      } else {
        this.booth_code = null;
        this.agent_code = null;
        this.business_details = null;
        this.business_available = false;
        alert('Agent or Booth not available');
      }
    }, (error) => {
      this.booth_code = null;
      this.agent_code = null;
      this.business_details = null;
      this.business_available = false;
      console.error(error);
    });
  }

  getData() {
    const data_dict = {
      agent_id: this.agent_id,
      from: 'portal'
    }
    this.httpService.serveTransactionLogAndWalletBalance(data_dict).subscribe((data) => {
      console.log(data);
      this.wallet_balance = data['wallet_balance'];
      // this.transaction_log_date_list = Object.keys(data['transaction_log']).sort().reverse();
      this.transaction_log = data['transaction_log'];
      console.log(this.transaction_log_date_list);
    }, (error) => {
      console.error(error);
    });
  }

  approve(element) {
    console.log()
    element['agent_id'] = element['transacted_by']
    const dialogRef = this.dialog.open(ChequeClearPopupComponent, {
      height: '600px',
      width: '600px',
      data: element
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');

      this.getData();
    })
  }

  getChequeApprovalStatus(id) {
    const data_dict = { 'transaction_log_id': id }
    this.httpService.getChequeStatusLogForIndividualTransaction(data_dict).subscribe((data: []) => {
      console.log(data);
      this.approve(data);
    }, (error) => {
      console.log(error);
    });
  }

  checkBorderColor(status_id) {
    if (status_id === 2) {
      return '10px solid green';
    } else {
      return '10px solid gray';
    }
  }

  ngOnInit() {
  }

}
